import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, throwError } from 'rxjs';
import { AppSettings } from '../app-settings';
import { SeasonProductAssignment } from '../interfaces/season';

@Injectable({
  providedIn: 'root'
})
export class SeasonService {

  constructor(private http: HttpClient) { }

  getSeasonsByCompany(companyId: number, search?: string) {
    let url = `${AppSettings.API_URI_V2}/companies/${companyId}/seasons`;
    if (search) url += `?search=${encodeURIComponent(search)}`;
    return this.http.get<any>(url).pipe(
      map((data) => data),
      catchError(err => throwError(() => err))
    );
  }

  getSeasonById(companyId: number, seasonId: number) {
    const url = `${AppSettings.API_URI_V2}/companies/${companyId}/seasons/${seasonId}`;
    return this.http.get<any>(url).pipe(
      map((data) => data),
      catchError(err => throwError(() => err))
    );
  }

  createSeason(companyId: number, payload: any) {
    const url = `${AppSettings.API_URI_V2}/companies/${companyId}/seasons`;
    return this.http.post<any>(url, payload).pipe(
      map((data) => data),
      catchError(err => throwError(() => err))
    );
  }

  updateSeason(companyId: number, seasonId: number, payload: any) {
    const url = `${AppSettings.API_URI_V2}/companies/${companyId}/seasons/${seasonId}`;
    return this.http.put<any>(url, payload).pipe(
      map((data) => data),
      catchError(err => throwError(() => err))
    );
  }

  toggleSeasonActive(companyId: number, seasonId: number) {
    const url = `${AppSettings.API_URI_V2}/companies/${companyId}/seasons/${seasonId}/toggle-active-status`;
    return this.http.put<any>(url, {}).pipe(
      map((data) => data),
      catchError(err => throwError(() => err))
    );
  }

  deleteSeason(companyId: number, seasonId: number) {
    const url = `${AppSettings.API_URI_V2}/companies/${companyId}/seasons/${seasonId}`;
    return this.http.delete<any>(url).pipe(
      map((data) => data),
      catchError(err => throwError(() => err))
    );
  }

  getPassesForSeason(companyId: number, seasonId: number, search?: string) {
    let url = `${AppSettings.API_URI_V2}/companies/${companyId}/seasons/${seasonId}/passes`;
    if (search) url += `?search=${encodeURIComponent(search)}`;
    return this.http.get<any>(url).pipe(
      map((data) => data),
      catchError(err => throwError(() => err))
    );
  }

  /**
   * Matriz de asignación de la temporada: qué producto se vende a qué categoría
   * de abonado en qué nivel de butaca. Devuelve `{ assignments, products }` —
   * los productos son los de la compañía, con su precio, que es lo que
   * diferencia un nivel de otro (cada categoría × nivel × variante es un
   * producto propio).
   */
  getProductAssignments(companyId: number, seasonId: number) {
    const url = `${AppSettings.API_URI_V2}/companies/${companyId}/seasons/${seasonId}/product-assignments`;
    return this.http.get<any>(url).pipe(
      map((data) => data),
      catchError(err => throwError(() => err))
    );
  }

  /**
   * Reemplaza la matriz completa: lo que se manda es lo que queda, así que hay
   * que enviar siempre todas las asignaciones, no solo las que han cambiado.
   */
  updateProductAssignments(companyId: number, seasonId: number, rows: SeasonProductAssignment[]) {
    const url = `${AppSettings.API_URI_V2}/companies/${companyId}/seasons/${seasonId}/product-assignments`;
    return this.http.put<any>(url, { rows }).pipe(
      map((data) => data),
      catchError(err => throwError(() => err))
    );
  }
}
